import { Component, OnInit } from '@angular/core';
import { GradeAgeAlignmentService } from '../../service/grade-age-alignment.service';

@Component({
  selector: 'view-grade-intersect',
  templateUrl: './view-grade-intersect.component.html',
  styleUrls: ['./view-grade-intersect.component.scss']
})
export class ViewGradeIntersectComponent implements OnInit {

  columns = {
    //'Region': { ENABLED: true, SORT: 'REGION.CODE', DISABLED: true },
    //'District': { ENABLED: true, SORT: 'SCHOOL_DISTRICTS.DISTRICTS', DISABLED: true },
    //'School': { ENABLED: true, SORT: 'SCHOOL.NAME', DISABLED: true },
    //'School Year': { ENABLED: true, SORT: 'SCHOOL.SCHOOL_YEAR', DISABLED: true },

    'MSD Number': { ENABLED: true, SORT: 'MSD_NUMBER', DISABLED: true },
    'SSID': { ENABLED: true, SORT: 'SSID', DISABLED: true },

    'Name': { ENABLED: true, SORT: 'PERSON.LAST_NAME', DISABLED: true },
    'DOB': { ENABLED: true, SORT: 'DOB', DISABLED: true },
    'Age': { ENABLED: true, SORT: 'AGE', DISABLED: true },
    //'Gender': { ENABLED: true, SORT: 'SEX', DISABLED: true },

    //'Grade': { ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE', DISABLED: true },
    //'Track': { ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].TRACK', DISABLED: true },
    //'Enroll Type': { ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE', DISABLED: true },

    'Enroll Date': { ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE', DISABLED: true },
    //'Withdrawal Date': { ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE', DISABLED: true },
    //'Departure Date': { ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].DEPARTURE_DATE', DISABLED: true },

    'Source': { ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].SOURCE', DISABLED: true },
};

  itemsPerPage: number = 10;
  loading: boolean = true;
  loadingPromises: any = [];
  currentSortValue: any;
  currentSecondarySortValue: any;
  secondarySortValue: any;
  loadingStatus: string = "";
  reverse: any;
  reverseFix: any;
  student: any;

  constructor( gradeAgeAlignmentService : GradeAgeAlignmentService ) { }

  ngOnInit(): void {

            this.getGradeAgeIntersectStudents();
            this.setAgeColumnTooltip();
  }

  getGradeAgeIntersectStudents() {
  //  var deferred = $q.defer();
   // .loadingPromises.push(deferred.promise);
    this.loadingStatus = 'Retrieving';

  /*  GradeAgeAlignmentService.search({
        chosenRegions: _.map(.chosenRegions, function (s) { return s.ID }),
        chosenCounties: _.map(.chosenCounties, function (s) { return s.ID }),
        chosenSchoolDistricts: _.map(.chosenSchoolDistricts, function (s) { return s.ID }),
        chosenSchools: _.map(.chosenSchools, function (s) { return s.ID }),
        schoolYear: _.property('schoolYear.year')(),
        performancePeriod: _.property('schoolYear.year')(), //_.property('performancePeriod.year')(),
        grade: .grade,
        age: .age
    }).then(function (res) {
        if (_.property('data.students')(res)) {
            .loadingStatus = 'Building';
            .students = JSON.parse(res.data.students);

            _.each(.students, function (student) {
                student.DOB = $filter('cleanDate')(student.DOB);
                student.AGE ? null : student.AGE = 0;
            });

            .currentPage = 1;

            .showMsg = false;
        }
        else if (_.property('data.msg.SUCCESS')(res) == false) {
            .msg = res.data.msg.MSG;
            .showMsg = true;
        }
        else {
            .msg = 'Error retrieving children.';
            .showMsg = true;
        }

        deferred.resolve();
    }, function (err) {
        .msg = 'Error retrieving children.';
        .showMsg = true;
        deferred.resolve();
    });*/
}

setAgeColumnTooltip() {
///    this.columns['Age']?.TOOLTIP = 'Age on 9/1/' + this.schoolYear?.current.toString();
}


setSort(sortValue: any, reverseFix: any, secondarySortValue: any) {
    if (this.currentSortValue === sortValue) {
        this.reverse = !this.reverse;
        if (secondarySortValue) {
            this.currentSecondarySortValue = secondarySortValue;
        }
        else {
            this.currentSecondarySortValue = 'PERSON.FIRST_NAME';
        }
        this.reverseFix ? this.reverseFix = '-' : this.reverseFix = '';

    }
    else {
      this.currentSortValue = sortValue;
        if (this.secondarySortValue) {
          this.currentSecondarySortValue = secondarySortValue;
        }
        else {
          this.currentSecondarySortValue = 'PERSON.FIRST_NAME';
        }
        this.reverse = false;
        this.reverseFix ? this.reverseFix = '-' : this.reverseFix = '';

    }
}

initSort() {
  this.currentSortValue ? null : this.setSort('PERSON.LAST_NAME', true, true);
}

}
